import React from "react";
import propTypes from "prop-types";

const ButtonWithIcon = ({
  onClick = null,
  type = "button",
  title = "title",
  src = "",
  className = "",
  isfull = false,
  isDisabled,
  isBackArrow = false,
  ...rest
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={`btn btn-primary  ${isfull ? "btn-full-width" : ""} ${className} ${isBackArrow ? "left-icon" : ""}`}
      {...rest}
    >
      {
        isBackArrow ? <img src={src} alt="" width="17" /> : null
      }
      {title}
      {
        !isBackArrow ? <img src={src} alt="" width="17" /> : null
      }
    </button>
  );
};

ButtonWithIcon.defaultProps = {
  isDisabled: false,
  type: undefined,
  onClick: undefined
}

ButtonWithIcon.propTypes = {
  onClick: propTypes.func,
  type: propTypes.string,
  title: propTypes.string.isRequired,
  src: propTypes.oneOfType([propTypes.object, propTypes.string]).isRequired,
  isDisabled: propTypes.bool
};

export default ButtonWithIcon;
